import { render, staticRenderFns } from "./POIFilePreview.vue?vue&type=template&id=067ed70a"
import script from "./POIFilePreview.js?vue&type=script&lang=js&external"
export * from "./POIFilePreview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports